import React from 'react';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { CalendarClockIcon, ExternalLinkIcon, LandmarkIcon, LockIcon, ReceiptIcon, WalletIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { PageHeader } from '../../components/ui/PageHeader';
import { selfPay } from '../../data/selfService';
import { TODAY, formatDate } from '../../utils/format';
export function MyPay() {
  const daysToPay = differenceInCalendarDays(parseISO(selfPay.nextPayDate), TODAY);
  const rows = [{
    label: 'Pay type',
    value: selfPay.payType
  }, {
    label: 'Pay rate',
    value: selfPay.rate
  }, {
    label: 'Overtime',
    value: selfPay.overtime
  }, {
    label: 'Pay schedule',
    value: selfPay.schedule
  }];
  return <div data-id="element-1736" data-mp="2n011pi95odh7">
      <PageHeader eyebrow="My pay" title="Pay" description="Read-only. Contact payroll if anything looks off." data-id="element-1737" data-mp="2n0arp5u7akmw" />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-3" data-id="element-1738" data-mp="2s0f16bwoyf3m">
        <Card title="Pay details" icon={WalletIcon} className="xl:col-span-2" data-id="element-1739" data-mp="2r9c0eb9u5flc">
          <dl className="divide-y divide-slate-100" data-id="element-1740" data-mp="2n9th1jxnxckm">
            {rows.map(r => <div key={r.label} className="grid grid-cols-1 gap-1 py-3.5 sm:grid-cols-[180px_minmax(0,1fr)] sm:gap-4" data-id="element-1741" data-mp="319co09eqmhvc">
                <dt className="text-sm text-muted" data-id="element-1742" data-mp="2warpqfj1q89j">{r.label}</dt>
                <dd className="text-sm font-medium text-navy" data-id="element-1743" data-mp="28jw0nq5z5r5z">{r.value}</dd>
              </div>)}
            <div className="grid grid-cols-1 gap-1 py-3.5 sm:grid-cols-[180px_minmax(0,1fr)] sm:gap-4" data-id="element-1744" data-mp="23lkqtffojgnr">
              <dt className="text-sm text-muted" data-id="element-1745" data-mp="2iagt0vv21zgg">Direct deposit</dt>
              <dd className="flex flex-wrap items-center gap-2 text-sm font-medium text-navy" data-id="element-1746" data-mp="2ibrwsvoi377k">
                <LandmarkIcon className="h-4 w-4 text-deep" aria-hidden="true" data-id="element-1747" data-mp="2dhfc6ibafpu8" />
                {selfPay.bank} <span className="font-mono tracking-wider" data-id="element-1748" data-mp="1prba4fdqzy5c">••••{selfPay.accountLast4}</span>
                <span className="inline-flex items-center gap-1 text-[11px] font-normal text-muted" data-id="element-1749" data-mp="1ksgt9izccjnv">
                  <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-1750" data-mp="3kuq233ajig58" /> Masked
                </span>
              </dd>
            </div>
          </dl>
        </Card>

        <div className="space-y-6" data-id="element-1751" data-mp="3unx72n1dbu4s">
          <section className="rounded-2xl bg-navy p-6 text-white shadow-lift" data-id="element-1752" data-mp="3uoqfdsfz6rp1">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10" data-id="element-1753" data-mp="2i1qygn23of6">
              <CalendarClockIcon className="h-5 w-5 text-flame" aria-hidden="true" data-id="element-1754" data-mp="31zjbsf1nzbwx" />
            </span>
            <p className="mt-5 text-xs font-medium uppercase tracking-wider text-white/55" data-id="element-1755" data-mp="36xbcnykae8d9">Next pay date</p>
            <p className="mt-1 text-2xl font-semibold" data-id="element-1756" data-mp="3b0r5ejt8joko">{formatDate(selfPay.nextPayDate, 'EEE, MMM d, yyyy')}</p>
            <p className="mt-1 text-sm text-white/70" data-id="element-1757" data-mp="3fvd900t2scu7">{daysToPay === 0 ? 'Today' : `In ${daysToPay} days`} · moved up from the 15th (Sunday)</p>
          </section>

          <Card title="Pay stubs" icon={ReceiptIcon} data-id="element-1758" data-mp="v5xkxdl8r289">
            <p className="text-sm text-slate-600" data-id="element-1759" data-mp="15b5vlfkhud1a">Pay stubs are managed by payroll.</p>
            <Button className="mt-4 w-full" icon={ExternalLinkIcon} onClick={() => toast('Opens the payroll portal', {
            description: 'Pay stubs and W-2s open in a new tab.'
          })} data-id="element-1760" data-mp="10ccfrghqi9xy">
              Open payroll portal
            </Button>
          </Card>
        </div>
      </div>
    </div>;
}